<div class="row no-gutters mt-4">
  <div class="col-6">
    <h5 class="section-title">Hold Points</h5>
    <h6 class="yellow" *ngIf="showNoHoldpointsFound">No Hold Points found!</h6>
  </div>
  <div class="col-6 d-print-none">
    <div class="button-container">
      <div class="d-flex align-items-center justify-content-end">
        <div
          class="button-wrapper mr-2"
          *ngIf="
            (status?.isEditing || status?.isEditingAmendment) &&
            canModifyHoldPoints &&
            (holdPoints?.length ?? 0) > 1 &&
            (privileges?.canAddHoldPoints || privileges?.canAddHoldPointsDraft)
          "
        >
          <button
            *ngIf="!enableReorder"
            mat-icon-button
            [disabled]="
              rsf &&
              rsf.status == formStatusEnum.Draft &&
              rsf.editingBy?.id != currentUser?.id &&
              rsf.editingBy?.id
            "
            color="accent"
            matTooltip="Enable Reorder Holdpoints"
            [ngClass]="{
              gray:
                rsf &&
                rsf.status == formStatusEnum.Draft &&
                rsf.editingBy?.id != currentUser?.id &&
                rsf.editingBy?.id,
            }"
            (click)="enableReorder = !enableReorder"
          >
            <mat-icon>swipe_vertical</mat-icon>
          </button>
          <button
            mat-mini-fab
            *ngIf="enableReorder"
            [disabled]="
              rsf &&
              rsf.status == formStatusEnum.Draft &&
              rsf.editingBy?.id != currentUser?.id &&
              rsf.editingBy?.id
            "
            color="accent"
            matTooltip="Disable Reorder Holdpoints"
            [ngClass]="{
              gray:
                rsf &&
                rsf.status == formStatusEnum.Draft &&
                rsf.editingBy?.id != currentUser?.id &&
                rsf.editingBy?.id,
            }"
            (click)="enableReorder = !enableReorder"
          >
            <mat-icon class="white">swipe_vertical</mat-icon>
          </button>
        </div>

        <button
          mat-flat-button
          color="accent"
          (click)="createHoldPoint()"
          *ngIf="
            (privileges?.canAddHoldPoints ||
              privileges?.canAddHoldPointsDraft) &&
            canModifyHoldPoints &&
            (status?.isEditing || status?.isEditingAmendment)
          "
          [disabled]="
            rsf &&
            rsf.status == formStatusEnum.Draft &&
            rsf.editingBy?.id != currentUser?.id &&
            rsf.editingBy?.id
          "
        >
          Add Hold Point
        </button>
      </div>

      <div
        *ngIf="
          rsf &&
          rsf.status == formStatusEnum.Draft &&
          rsf.editingBy?.id != currentUser?.id &&
          rsf.editingBy?.id
        "
        class="disabled-message"
      >
        You cannot add or modify hold points while the form is being edited
      </div>
    </div>
  </div>
</div>

<div
  cdkDropList
  [cdkDropListData]="holdPoints"
  [cdkDropListSortPredicate]="canSortHoldPoint"
  (cdkDropListDropped)="drop($event)"
  class="holdpoints-container"
  cdkDropListLockAxis="y"
  [cdkDropListDisabled]="isLogView"
>
  <div
    *ngFor="let hp of holdPoints; let i = index"
    cdkDrag
    [cdkDragData]="hp"
    class="d-flex align-items-center"
    [cdkDragDisabled]="isHoldPointDragDisabled(hp)"
  >
    <button
      mat-icon-button
      *ngIf="enableReorder"
      cdkDragHandle
      class="yellow"
      [ngClass]="{
        'drag-disabled': isHoldPointDragDisabled(hp),
      }"
      [cdkDragHandleDisabled]="isHoldPointDragDisabled(hp)"
      [disabled]="isHoldPointDragDisabled(hp)"
    >
      <mat-icon>reorder</mat-icon>
    </button>
    <div
      class="row full-width border-hp relative mx-1"
      [ngClass]="{
        'border-hp-amendment': diffHoldpoint(hp),
      }"
      *ngIf="
        !hp.rsfAmendmentID ||
        (hp.rsfAmendmentID &&
          (status?.isViewingAmendment || !amendmentActive() || isLogView))
      "
    >
      <span
        class="holdpoint-title"
        *ngIf="hp.number"
        [ngClass]="{
          'holdpoint-amendment-title': diffHoldpoint(hp),
        }"
        >Hold Point {{ hp.number
        }}<span class="ml-2" *ngIf="hp.rsfAmendmentID && diffHoldpoint(hp)"
          >Amendment {{ hp.rsfAmendment?.number }}</span
        ></span
      >
      <span class="holdpoint-buttons d-print-none">
        <button
          type="button"
          mat-icon-button
          color="accent"
          (click)="editHoldPoint(hp)"
          *ngIf="
            (privileges?.canAddHoldPoints ||
              privileges?.canAddHoldPointsDraft) &&
            canModifyHoldPoints &&
            holdPointUnsigned(hp) &&
            (status?.isEditing || status?.isEditingAmendment)
          "
          [disabled]="
            rsf &&
            rsf.status == formStatusEnum.Draft &&
            rsf.editingBy?.id != currentUser?.id &&
            rsf.editingBy?.id
          "
        >
          <mat-icon>edit</mat-icon>
        </button>
        <button
          type="button"
          mat-icon-button
          color="warn"
          (click)="deleteHoldPoint(hp)"
          *ngIf="
            (privileges?.canAddHoldPoints ||
              privileges?.canAddHoldPointsDraft) &&
            canModifyHoldPoints &&
            holdPointUnsigned(hp) &&
            (status?.isEditing || status?.isEditingAmendment)
          "
          [disabled]="
            rsf &&
            rsf.status == formStatusEnum.Draft &&
            rsf.editingBy?.id != currentUser?.id &&
            rsf.editingBy?.id
          "
        >
          <mat-icon>delete</mat-icon>
        </button>
      </span>
      <div class="col-12 mt-3">
        <div class="holdpoint-comment">
          <span [innerHTML]="hp.description"> </span>
        </div>
        <div class="row px-2 justify-content-center">
          <div
            class="col px-1 pb-2"
            id="{{ s.disapproveAction }}"
            *ngFor="let s of hp.signatures"
          >
            <button-signature
              #btnSign
              [roleIds]="s.roles"
              [roleCodes]="s.roleCodes"
              [user]="s.approvedBy"
              [title]="s.name"
              [disabled]="s.disabled"
              [value]="s.approved"
              [showApprove]="s.approveAction && !!s.approveActionId"
              [showDisapprove]="s.disapproveAction && !!s.disapproveActionId"
              [showUnapprove]="s.unapproveAction && !!s.unapproveActionId"
              [showTestApprove]="canTestSign(s)"
              [date]="s.approvedOn"
              (approve)="sign(s, wfAction.Approve)"
              (disapprove)="sign(s, wfAction.Disapprove, $event)"
              (unapprove)="sign(s, wfAction.Unapprove)"
              (testApprove)="testSign(s)"
              [enabled]="s.enabled"
              [userNames]="s.userNames"
            ></button-signature>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <form-workflow
  [form]="rsf"
  [sectionNumber]="4"
  [service]="service"
  [disabled]="disabled"
  [hideTitle]="true"
></form-workflow> -->
